export default {
  buttonLabel: `Get started`,
  intro: {
    h2: `Do you want to take a relationship with someone you know to the next level?`,
    p: `CrushPledge helps you safely find out if this person feels the same way about you. We won’t reveal your identity unless both parties express mutual feelings, so you’re safe from embarrassment or awkwardness.`
  },
  how: {
    h1: `How it works`,
    step1Title: `Pledge your love`,
    step1: `Make a $10 pledge to one of our featured charities. We require this to ensure you’re serious about your feelings (and to pay it forward to deserving causes). This pledge becomes an actual donation (meaning your credit card is charged) ONLY if a match is made.`,
    step2Title: `Send your love`,
    step2: `Tell us who is making your pulse race. We’ll send them a message saying someone’s fallen hard for them!`,
    step3Title: `Fall in love`,
    step3: `We’ll prompt your crush to identify who they hope has feelings for them. If it’s you, we’ll let each person know a match has been made. Start making dinner reservations for two! Note: We require your crush to make a $10 pledge as well. This prevents them from guessing “just for fun” and verifies their feelings are just as legitimate as yours.`
  },
  success: {
    h3: `If a successful match does not occur within 30 days, we delete all your personal information and your pledge is voided.`
  },
  bottom: {
    note: `Please note: CrushPledge deducts 3% from the donation if there’s a match and the transaction is processed. This minimal amount is used to keep the office lights on, the site running, and other business functions operating. No profits go in our personal pockets, and in fact, we pledge any profits to <a href="http://firstdescents.org" target="_blank">FirstDescents</a> and <a href="http://www.marchofdimes.org/" target="_blank">March of Dimes</a>`
  }
};



// WEBPACK FOOTER //
// ./assets/strings/how.js